import { render } from "./SenaraiIbayaq.vue?vue&type=template&id=58cb9f0a"
import script from "./SenaraiIbayaq.vue?vue&type=script&lang=js"
export * from "./SenaraiIbayaq.vue?vue&type=script&lang=js"

import "./SenaraiIbayaq.vue?vue&type=style&index=0&id=58cb9f0a&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__